<template>
  <div class="calworkhoursv2-container">
    <el-row>
      <el-form :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="50px" class="demo-ruleForm">
        <el-form-item label="月份" prop="month">
          <el-date-picker v-model="ruleForm.month" type="month" placeholder="选择月" value-format="yyyy-MM"></el-date-picker>
        </el-form-item>
        <el-form-item label="token" prop="token" class="token-item">
          <el-input v-model="ruleForm.token" type="textarea" class="token-input" placeholder="中软门户->个人考勤->f12，找个有token的接口复制到此"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="calV3('ruleForm')">计算</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <span>ps：周末工时不计入其中，因节假日导致周末补班需自行计算周末时长</span>
    <el-divider></el-divider>
    <el-row v-show="show" :gutter="15">
      <el-col :span="14" :offset="1">
        <el-card class="box-card" style="width: 100%">
          <template>
            <el-table
              :data="tableData"
              stripe
              style="width: 100%">
              <el-table-column
                type="index"
                width="40">
              </el-table-column>
              <el-table-column
                prop="date"
                label="日期"
                width="160">
              </el-table-column>
              <el-table-column
                prop="weekNo"
                label="周号"
                width="120">
                <template slot-scope="scope">
                  <el-tag
                    :type="scope.row.weekNo === '周六' || scope.row.weekNo === '周日' ? 'danger' : 'success'"
                    disable-transitions>{{ scope.row.weekNo }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="startTime"
                label="上班打卡"
                width="120">
              </el-table-column>
              <el-table-column
                prop="startEffectiveTime"
                label="上班生效"
                width="120">
              </el-table-column>
              <el-table-column
                prop="endTime"
                label="下班打卡"
                width="120">
              </el-table-column>
              <el-table-column
                prop="extraWorkHours"
                label="额外工时"
                width="180">
              </el-table-column>
              <el-table-column
                prop="totalWorkHours"
                label="总计工时"
                width="180">
              </el-table-column>
            </el-table>
          </template>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <el-descriptions title="总计" direction="vertical" :column="1" border>
            <el-descriptions-item label="当月额外工时">{{ extraWorkHoursMouth }}</el-descriptions-item>
            <el-descriptions-item label="当月总计工时（8小时制）">{{ totalWorkHoursMouth }}</el-descriptions-item>
            <el-descriptions-item label="本周日期">{{ currentWeekDateAll }}</el-descriptions-item>
            <el-descriptions-item label="本周额外工时">{{ extraWorkHoursWeek }}</el-descriptions-item>
            <el-descriptions-item label="本周总计工时（8小时制）">{{ totalWorkHoursWeek }}</el-descriptions-item>
          </el-descriptions>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {zrv2, zrv3} from '../api/calWorkHours'
import axios from 'axios'

export default {
  name: 'calWorkHoursv2',
  data () {
    return {
      ruleForm: {
        month: '',
        cookie: '',
        token: ''
      },
      msg: '',
      workHoursUrl: 'https://yihr.chinasoftinc.com:18010/ehr_saas/web/icssAttEmpDetail/getLocSetDataByPage.empweb',
      show: false,
      currentWeekDateAll: [],
      extraWorkHoursWeek: '',
      totalWorkHoursWeek: '',
      extraWorkHoursMouth: '',
      totalWorkHoursMouth: '',
      tableData: [],
      rules: {
        token: [
          {required: true, message: '请输入token', trigger: 'blur'}
        ],
        month: [
          {required: true, message: '请选择月份', trigger: 'change'}
        ]
      }
    }
  },
  methods: {
    cal (ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm.month)
          const data = '{"month":"' + this.ruleForm.month + '","cookie":"' + this.ruleForm.cookie + '","token":"' + this.ruleForm.token.trim().replaceAll('\r|\n', '') + '"}'
          zrv2(data).then(response => {
            this.tableData = response.data.zrv2Daily
            this.currentWeekDateAll = response.data.currentWeekDateAll
            this.extraWorkHoursWeek = response.data.extraWorkHoursWeek
            this.totalWorkHoursWeek = response.data.totalWorkHoursWeek
            this.extraWorkHoursMouth = response.data.extraWorkHoursMouth
            this.totalWorkHoursMouth = response.data.totalWorkHoursMouth
            this.msg = response.data.msg
            if (this.msg === '' || this.msg === null) {
              this.show = true
            } else {
              this.$message.error(this.msg)
              this.show = false
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    async calV3 (ruleForm) {
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          console.log(this.ruleForm.month)
          try {
            const data = await axios.get(this.workHoursUrl + '?pageIndex=1&pageSize=100&search=%7B%22dt%22%3A%22' + this.ruleForm.month + '%22%7D', {
              headers: {
                'Token': this.ruleForm.token.trim().replaceAll('\r|\n', '')
              }
            })

            console.log('data.JSON:' + JSON.stringify(data))
            console.log('data.str:' + data)
            zrv3(data.data).then(response => {
              this.tableData = response.data.zrv2Daily
              this.currentWeekDateAll = response.data.currentWeekDateAll
              this.extraWorkHoursWeek = response.data.extraWorkHoursWeek
              this.totalWorkHoursWeek = response.data.totalWorkHoursWeek
              this.extraWorkHoursMouth = response.data.extraWorkHoursMouth
              this.totalWorkHoursMouth = response.data.totalWorkHoursMouth
              this.msg = response.data.msg
              if (this.msg === '' || this.msg === null) {
                this.show = true
              } else {
                this.$message.error(this.msg)
                this.show = false
              }
            })
          } catch (error) {
            this.error = error.message
            console.error('Error fetching data:', error)
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.calworkhoursv2-container {
  padding: 20px;
  max-width: 1600px;
  margin: 0 auto;
}
.token-item {
  width: 500px;
}
.token-input {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/view/calWorkHoursv2.vue